import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import usersReducer from './slices/usersSlice';
import summariesReducer from './slices/summariesSlice';
import adminReducer from './slices/adminSlice';
import chatReducer from './slices/chatSlice';
import processesReducer from './slices/processesSlice';
import notificationReducer from './slices/notificationSlice';
import customerProfilingReducer from './slices/customerProfilingSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    users: usersReducer,
    summaries: summariesReducer,
    admin: adminReducer,
    chat: chatReducer,
    processes: processesReducer,
    notifications: notificationReducer,
    customerProfiling: customerProfilingReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
